"use client";

import { useSession } from "@/components/SupabaseProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
import { PlanType } from "../const/planConst";
import { PROFILE_QUERY_KEY } from "./useProfile";

const getClientReferenceId = () => {
  // @ts-ignore
  return window.Rewardful && window.Rewardful.referral;
};

// For performing the actual update
export const useSubscriptionUpdate = () => {
  const session = useSession();
  const queryClient = useQueryClient();
  const posthog = usePostHog();
  return useMutation({
    mutationFn: async (plan: PlanType) => {
      posthog?.capture("Request Subscription Update", {
        plan,
      });

      const referral = getClientReferenceId();
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/billing/subscription`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${session?.access_token}`,
          },
          body: JSON.stringify({
            plan,
            referral,
          }),
        }
      );

      if (res.status === 401) {
        throw new Error("Please login to continue");
      }
      if (!res.ok) {
        throw new Error(`Something went wrong (status ${res.status})`);
      }

      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: ["subscriptions"] });

      return res.json();
    },
  });
};
